import { useEffect } from "react";
import { useRuntimeContext } from "@/features/tutor/context/RuntimeContext";

/**
 * Forwards CANVAS_CAPTIONS_UPDATE chunks (dispatched as window events by
 * canvas/agent/transport.ts) onto the RuntimeContext bus as CAPTIONS_UPDATE
 * so the tutor's useCaptionsQueue handles them transparently.
 *
 * Mount once inside the RuntimeProvider tree (e.g. in VoDemo).
 */
export function CanvasCaptionsBridge() {
  const { emit } = useRuntimeContext();

  useEffect(() => {
    const handler = (event: Event) => {
      const chunk = (
        event as CustomEvent<{ chunk_data?: string; turn_id?: string }>
      ).detail;
      if (!chunk || typeof chunk.chunk_data !== "string") return;
      emit("CAPTIONS_UPDATE", {
        chunk_data: chunk.chunk_data,
        turn_id: chunk.turn_id ?? "",
      });
    };

    window.addEventListener("canvas:captions-update", handler);
    return () => window.removeEventListener("canvas:captions-update", handler);
  }, [emit]);

  return null;
}
